"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchDarklyLogger = void 0;
exports.launchDarklyLogger = {
    debug: () => { }, // No-op for debug
    info: () => { }, // No-op for info
    warn: () => { }, // No-op for warn
    error: (message) => {
        console.error(message); // Only log errors
    }
};
